import { render, staticRenderFns } from "./LayoutClick.vue?vue&type=template&id=ba9e6062&"
import script from "./LayoutClick.vue?vue&type=script&lang=js&"
export * from "./LayoutClick.vue?vue&type=script&lang=js&"
import style0 from "./LayoutClick.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports